import { combineReducers } from "redux";
import room from "./room";
import me from "./me";
import producers from "./producers";
import peers from "./peers";
import lobbyPeers from "./lobbyPeers";
import consumers from "./consumers";
import peerVolumes from "./peerVolumes";
import notifications from "./notifications";
import chat from "./chat";
import privateChat from "./privateChat";
import toolarea from "./toolarea";
import settings from "./settings";
import user from "./user";
import whiteboard from "./whiteboard";
import survey from "./survey";
import call from "./call";
import userManagement from "./Management/userManagement";
import groupManagement from "./Management/groupManagement";
import meetingManagement from "./Management/meetingManagement";
import ldapManagement from "./Management/ldapManagement";
import messagingManagement from "./Management/messagingManagement";
import cloud from "./cloud";
import noteManagement from "./Management/noteManagement";
import poll from "./poll";
import focus from "./focus";
import feed from "./feed";
import remoteControl from "./remoteControl";
export default combineReducers({
  room, //*
  me, //*
  producers, //*
  peers, //*
  lobbyPeers, //*
  consumers, //*
  peerVolumes, //*
  notifications,
  chat, //*
  privateChat, //*
  toolarea, //*
  settings,
  user,
  whiteboard, //*
  survey, //*
  call,
  userManagement,
  groupManagement,
  meetingManagement,
  ldapManagement,
  messagingManagement,
  cloud,
  noteManagement,
  poll,
  feed,
  focus,
  remoteControl,
});
